import { useMemo, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { AlertWithActionsProps, AlertWithActionsType } from '@masfront/common-b2c'

import useSelectLine from './useSelectLine'

import useModal from '../../modal/hooks/useModal'
import { TRY_AGAIN, CONTINUE, NEW_NUMBER_FAILED } from '../constants/errors'
import { fetchNewNumberData } from '../store/line.reducer'

export const NO_PHONE_NUMBER = 'No hay numeración disponible'
export const LOADING_MESSAGE = 'Creando número nuevo...'
export const SUCCESS_MESSAGE = 'Este es el nuevo número:'

export default function useNewProduct(isNewProduct: boolean, id: string): AlertWithActionsProps {
  const dispatch = useDispatch()
  const { newNumber, isNewNumberLoading, newNumberError } = useSelectLine(id)
  const { setModalConfig, setIsOpen } = useModal()

  const isError = !!newNumberError || !newNumber
  const isDoneLoading = isNewNumberLoading === false

  const notificationConfiguration: AlertWithActionsProps = useMemo(() => {
    function onRetryRequest() {
      if (newNumberError) {
        dispatch(fetchNewNumberData(id))
      }
    }

    if (!!newNumber && isNewNumberLoading === false)
      return {
        type: AlertWithActionsType.success,
        text: `${SUCCESS_MESSAGE} ${newNumber}`,
        actions: [],
      }
    if ((!!newNumberError || !newNumber) && isNewNumberLoading === false)
      return {
        type: AlertWithActionsType.error,
        text: newNumberError ? NEW_NUMBER_FAILED : NO_PHONE_NUMBER,
        actions: newNumberError ? [{ name: TRY_AGAIN, fn: onRetryRequest }] : [{ name: CONTINUE }],
      }
    return {
      type: AlertWithActionsType.loading,
      text: LOADING_MESSAGE,
      actions: [],
    }
  }, [newNumber, isNewNumberLoading, newNumberError, id, dispatch])

  useEffect(() => {
    if (!newNumber && isNewProduct) {
      dispatch(fetchNewNumberData(id))
    }
  }, [dispatch, isNewProduct, id, newNumber])

  useEffect(() => {
    if (isError && isDoneLoading) {
      setModalConfig({
        open: false,
        title: notificationConfiguration?.text,
        ...notificationConfiguration,
      })
      setIsOpen(true)
    }
  }, [isDoneLoading, isError])

  return {
    ...notificationConfiguration,
  }
}
